import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IShoppingCart } from "./models";

const initialState: IShoppingCart = {
  success: false,
};

export default function shoppingCartReducer(
  state: IShoppingCart,
  action: Action,
): IShoppingCart {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const data = (action as PayloadAction<IShoppingCart>).payload;
      return { ...data };
    }
    default:
      return state;
  }
}
